import { Box, Drawer as MuiDrawer, Stack, styled } from '@mui/material';

export const Drawer = styled(MuiDrawer)`
  .MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.24);
  }
  .MuiPaper-root {
    width: 100%;
    height: calc(100vh - 72px);
    box-shadow: 0 -16px 32px 0 rgba(0, 0, 0, 0.08);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  &.expand .MuiPaper-root {
    height: 100vh;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const BottomSheetInner = styled(Stack)`
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const BottomSheetHeader = styled(Stack)`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 6px 20px;
  background-color: rgba(249, 250, 251, 0.9);
  border-bottom: 1px solid var(--dk-line, #e7e9ec);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  h1 {
    margin: 0;
    font-weight: 500;
    font-size: 16px;
    color: var(--dk-text, black);
  }
`;

export const BottomSheetBody = styled(Box)`
  flex: 1;
  overflow-y: auto;
`;
